import { useState } from "react";
import useLenis from "@/hooks/useLenis";
import Grain from "@/components/Grain";
import Navbar from "@/components/Navbar";
import Chatbot from "@/components/Chatbot";
import EnrollDialog from "@/components/EnrollDialog";
import LeadMagnetDialog from "@/components/LeadMagnetDialog";
import Hero from "@/components/sections/Hero";
import Countdown from "@/components/sections/Countdown";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import Manifesto from "@/components/sections/Manifesto";
import Syllabus from "@/components/sections/Syllabus";
import Roadmap from "@/components/sections/Roadmap";
import Readiness from "@/components/sections/Readiness";
import HostBio from "@/components/sections/HostBio";
import LeadMagnet from "@/components/sections/LeadMagnet";
import Faq from "@/components/sections/Faq";
import { FinalCta, Footer } from "@/components/sections/Footer";

export default function Landing() {
  useLenis();
  const [enrollOpen, setEnrollOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const openEnroll = () => setEnrollOpen(true);
  const openLead = () => setLeadOpen(true);

  return (
    <div className="dark relative min-h-screen bg-ink text-cream" data-testid="landing-page">
      <Grain />
      <Navbar onRegister={openEnroll} />
      <main>
        <Hero onRegister={openEnroll} />
        <Countdown onRegister={openEnroll} />
        <EditorialMarquee />
        <Manifesto />
        <Syllabus />
        <Roadmap onRegister={openEnroll} />
        <Readiness onRegister={openEnroll} />
        <HostBio />
        <LeadMagnet onDownload={openLead} />
        <Faq />
        <FinalCta onRegister={openEnroll} />
        <Footer />
      </main>
      <Chatbot />
      <EnrollDialog open={enrollOpen} onOpenChange={setEnrollOpen} />
      <LeadMagnetDialog open={leadOpen} onOpenChange={setLeadOpen} />
    </div>
  );
}
